module.exports = __webpack_public_path__ + "img/2f049d85d3095fe905b6bd963d5cba52.2f049d85.png";